var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.refresh
    ? _c("BjGraph", {
        attrs: {
          "left-addon": _vm.hasPermissionBtn,
          menu: _vm.hasPermissionBtn,
          api: _vm.api,
          movable: _vm.hasPermissionBtn,
        },
        on: { refresh: _vm.refreshData },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }